export const ACTION_TICKET_SUBMIT = 'ACTION_TICKET_SUBMIT'
export const ACTION_TICKET_ASK_REPLY = 'ACTION_TICKET_ASK_REPLY'
export const ACTION_TICKET_SUBMIT_REPLY = 'ACTION_TICKET_SUBMIT_REPLY'
